import { useTranslation } from 'react-i18next';
import { QueryKeys } from '@connect-x-app/shared-domain-models';
import { deleteSmartAction } from '@connect-x-app/web-data-access';
import { toastError, toastSuccess } from '@connect-x-app/web-ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useDeleteSmartAction = () => {
  const queryClient = useQueryClient();

  const { t } = useTranslation();

  const mutation = useMutation({ mutationFn: deleteSmartAction, mutationKey: [QueryKeys.SMART_ACTIONS] });

  const deleteSmartActions = async (ids: string[]) => {
    const results = await Promise.allSettled(ids.map(id => mutation.mutateAsync(id)));

    queryClient.invalidateQueries({ queryKey: [QueryKeys.SMART_ACTIONS] });

    const fulfilled = results.filter(result => result.status === 'fulfilled');

    if (fulfilled.length !== results.length) {
      toastError(t('TOAST_ERROR'));
      return undefined;
    }

    toastSuccess(t('TOAST_SUCCESS'));
    return fulfilled.map(({ value }) => value);
  };

  return { ...mutation, deleteSmartActions: deleteSmartActions };
};
